import { useState, useEffect } from 'react';
import axios from 'axios';
import { EmbeddedImage, RichNote } from '@/components/SupportImages';
import { fmtDay } from '@/utils/dateFmt';

const API = process.env.REACT_APP_BACKEND_URL;

export default function GuiaPage() {
  const [guide, setGuide] = useState(undefined);
  useEffect(() => { axios.get(`${API}/api/me/guide`, { withCredentials: true }).then(r => setGuide(r.data)).catch(() => setGuide(null)); }, []);
  const pdf = async () => {
    const { data: me } = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
    const r = await axios.get(`${API}/api/patients/${me.user_id}/guide/pdf`, { responseType: 'blob', withCredentials: true });
    window.open(URL.createObjectURL(r.data), '_blank');
  };
  if (guide === undefined) return null;
  return (
    <div className="space-y-4 pb-24" data-testid="guia-page">
      <div className="flex items-center justify-between"><h1 className="font-heading font-medium text-2xl text-brand-text">Guia de orientações</h1>
        {guide && <button onClick={pdf} className="text-xs border border-brand-border rounded-full px-3 py-1.5" data-testid="guia-pdf-btn">Descarregar PDF</button>}</div>
      {!guide ? <p className="text-sm text-brand-muted" data-testid="guia-empty">Ainda não tens um guia publicado.</p> : (
        <>
          <p className="text-[11px] text-brand-muted">Atualizado em {fmtDay(guide.published_at)}</p>
          {guide.sections.map(s => (
            <section key={s.key} className="bg-white border border-brand-border rounded-3xl p-4" data-testid={`guia-section-${s.key}`}>
              <h2 className="font-heading font-medium text-brand-green mb-1.5">{s.title}</h2>
              {s.text && <RichNote text={s.text} className="text-sm text-brand-text" />}
              <div className="flex flex-col gap-2 mt-2">{(s.images || []).map(id => <EmbeddedImage key={id} id={id} />)}</div>
            </section>))}
        </>
      )}
    </div>
  );
}
